// Общий хук для экранов 3 «Моя подписка» и 4 «Устройства» (ТЗ раздел 3.3) — оба показывают один и
// тот же fetchSubscription()/subscriptionStore на старте, отличается только то, что делают с
// результатом дальше. Вынесено сюда после появления второго потребителя.
import { useEffect } from "react";

import { ApiError, fetchSubscription } from "../api/client";
import { useSubscriptionStore } from "../store/subscriptionStore";

export function useSubscription() {
  const store = useSubscriptionStore();
  const { setLoading, setSubscription, setError } = store;

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchSubscription()
      .then((data) => {
        if (!cancelled) setSubscription(data);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof ApiError ? err.message : String(err));
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- store-сеттеры стабильны (zustand), не нужны в deps
  }, []);

  return store;
}
